var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTexterBigLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1250_2585)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.8276 19.9137C39.8276 8.91564 30.9119 -7.24792e-05 19.9138 -7.24792e-05C8.91571 -7.24792e-05 0 8.91564 0 19.9137C0 30.9118 8.91571 39.8275 19.9138 39.8275C30.9119 39.8275 39.8276 30.9118 39.8276 19.9137Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.4728 38.7071L30.6789 36.6191L36.3844 30.9135L38.4728 38.7071Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2528 29V28.1074H17.5699V13.825H16.5526C15.3187 13.825 14.3438 14.1901 13.628 14.9204C12.9215 15.6507 12.2951 16.9489 11.7488 18.8152H11L11.2261 12H28.7598L29 18.8152H28.2512C27.7331 17.003 27.1115 15.7183 26.3862 14.9609C25.6609 14.2036 24.7002 13.825 23.5039 13.825H22.4301V28.1074H24.7473V29H15.2528Z",
  fill: "#637EF5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1250_2585"
}, /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  fill: "white"
})))));
export { SvgTexterBigLogo as ReactComponent };
export default __webpack_public_path__ + "7f14021eca1b7888468cfd26aeaa480e.svg";